<script>
import { getYouTubeVideoId } from '../../../shared/youtube'

export default {
  name: 'AnnouncementVideo',
  props: {
    url: { type: String, default: '' }
  },
  computed: {
    videoId () {
      return getYouTubeVideoId(this.url)
    },
    thumbnailUrl () {
      return `https://i.ytimg.com/vi/${this.videoId}/hqdefault.jpg`
    },
    watchUrl () {
      return `https://www.youtube.com/watch?v=${this.videoId}`
    }
  }
}
</script>

<template>
  <div v-if="videoId" class="announcement-video">
    <a :href="watchUrl" target="_blank" rel="noopener noreferrer" class="announcement-video-preview" aria-label="ดูวิดีโอประกาศบน YouTube">
      <img :src="thumbnailUrl" alt="ภาพตัวอย่างวิดีโอประกาศ" />
      <span class="announcement-video-play" aria-hidden="true">▶</span>
    </a>
    <a :href="watchUrl" target="_blank" rel="noopener noreferrer" class="announcement-video-link">
      ดูวิดีโอบน YouTube ↗
    </a>
  </div>
</template>

<style scoped>
.announcement-video {
  margin: 16px 0;
  text-align: center;
}
.announcement-video-preview {
  display: block;
  position: relative;
  width: 100%;
  overflow: hidden;
  border-radius: 8px;
  background: #000;
}
.announcement-video-preview img {
  display: block;
  width: 100%;
  aspect-ratio: 16 / 9;
  object-fit: cover;
}
.announcement-video-play {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 12px;
  padding: 12px 22px;
  background: #c00;
  color: #fff;
  font-size: 24px;
  line-height: 1;
}
.announcement-video-link {
  display: inline-block;
  margin-top: 10px;
  color: #fec33f;
  text-decoration: underline;
}
</style>
